/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Support_Desc7Inputs */

const en_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixes and small tweaks included after launch, then a clean handoff.`)
};

const ar_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إصلاحات وتعديلات صغيرة مشمولة بعد الإطلاق، ثم تسليم نظيف.`)
};

const bn_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লঞ্চের পর ফিক্স আর ছোটখাটো বদল অন্তর্ভুক্ত, তারপর পরিষ্কার হস্তান্তর।`)
};

const de_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixes und kleine Anpassungen nach dem Start inklusive, dann eine saubere Übergabe.`)
};

const es_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correcciones y pequeños ajustes incluidos tras el lanzamiento, luego una entrega limpia.`)
};

const fr_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrections et petits ajustements inclus après le lancement, puis une passation propre.`)
};

const pt_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correções e pequenos ajustes incluídos após o lançamento, depois uma entrega limpa.`)
};

const zh_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上线后的修复和小调整都包含在内，然后干净交接。`)
};

const tr_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansman sonrası düzeltmeler ve küçük rötuşlar dahil, sonra temiz devir.`)
};

const ru_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фиксы и мелкие правки после запуска включены, затем чистая передача.`)
};

const pl_svc_mvp_sprint_support_desc7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprawki i drobne korekty po starcie wliczone, potem czyste przekazanie.`)
};

/**
* | output |
* | --- |
* | "Fixes and small tweaks included after launch, then a clean handoff." |
*
* @param {Svc_Mvp_Sprint_Support_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_support_desc7 = /** @type {((inputs?: Svc_Mvp_Sprint_Support_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Support_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "de") return de_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "es") return es_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_support_desc7(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_support_desc7(inputs)
	return en_svc_mvp_sprint_support_desc7(inputs)
});
export { svc_mvp_sprint_support_desc7 as "svc_mvp-sprint_SUPPORT_desc" }